import { BaseModel } from '~/models/baseModel';

export class LinkModel extends BaseModel {
    public raw:string;
    public name:string;
    public url:string;
}
